/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import {apiInstance} from "../../Apis/Axios";
import { ASSETS_SERVICE } from '../EndPoints';

const GET_ALL_APPROVAL = 'approvalflow-service/get-all-active-approval-flows';
const CREATE_APPROVAL = 'approvalflow-service/create';
const GET_ALL_APPROVAL_BY_ID = 'approvalflow-service/get-by-id';
const UPDATE_APPROVAL = 'approvalflow-service/update';
const GET_APPROVAL_MODULES = 'approvalflow-service/get-all-modules';

// List all the approval

export const GetAllApproval = createAsyncThunk(
    'approvalSection/getAllApproval',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(GET_ALL_APPROVAL)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
// create approval
export const CreateApproval = createAsyncThunk(
    'approvalSection/createApproval',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(CREATE_APPROVAL, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// update approval
export const UpdateApproval = createAsyncThunk(
    'approvalSection/updateApproval',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(UPDATE_APPROVAL, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// get approval by it id
export const GetApprovalById = createAsyncThunk(
    'approvalSection/getApprovalById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${GET_ALL_APPROVAL_BY_ID}/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// List all the possible modules
export const GetListApprovalModules = createAsyncThunk(
    'approvalSection/getListApprovalModules',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(GET_APPROVAL_MODULES)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

